import React from "react";
import { styled } from "@mui/material";

const ColumnHeaderStyled = styled("div")({
  display: "flex",
  flexFlow: "row",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 8,
  "& h3": {
    margin: "8px 0",
    lineHeight: 1.2,
  },
});

const TopButtons = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 8,
});

type ColumnHeaderProps = {
  title: string;
  children?: React.ReactNode;
  buttons?: React.ReactNode;
};

const ColumnHeader = ({ title, buttons, children }: ColumnHeaderProps) => {
  return (
    <ColumnHeaderStyled className={"column-header"}>
      <h3>{title}</h3>
      {children && <div style={{ flex: 1 }}>{children}</div>}
      {buttons && <TopButtons>{buttons}</TopButtons>}
    </ColumnHeaderStyled>
  );
};

export default ColumnHeader;
